// extracted by mini-css-extract-plugin
export default {"input":"ri4MW7PpHzD6UKh24TVs","isInvalid":"Zjxjs2C1IGH_ZjJtZWCk"};